import gql from 'graphql-tag';

const externalOnboardingQueueQuery = gql`
  query ExternalOnboardingQueue(
    $view: String
    $search: String
    $from: String
    $to: String
    $sort: String
    $order: String
    $page: Int
    $size: Int
  ) {
    externalOnboardingQueue(
      view: $view
      search: $search
      from: $from
      to: $to
      sort: $sort
      order: $order
      page: $page
      size: $size
    ) {
      totalRows
      totalDealers
      page
      size
      items {
        flatRateOfferBatchId
        dealers {
          flatRateOfferId
          flatRateOfferBatchId
          customerId
          status
          offerAcceptedDate
          dealerName
          dealerEmail
          dealerPhone
          createdAt
          completedAt
          updatedAt
          updatedBy
          noteCount
          reason
          productType
          productName
          subscriptionPrice
        }
      }
    }
  }
`;

export default externalOnboardingQueueQuery;
